var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollapseUp = function SvgCollapseUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.81 10.616a.597.597 0 0 1-.844 0L9 8.651l-1.965 1.965a.597.597 0 1 1-.844-.844l2.387-2.387a.597.597 0 0 1 .844 0l2.388 2.387a.597.597 0 0 1 0 .844Z",
    fill: "#233918"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 17.5,
    width: 17,
    height: 17,
    rx: 1.5,
    transform: "rotate(-180 17.5 17.5)",
    stroke: "#C8CDC5"
  })));
};
export default SvgCollapseUp;